
import UsuarioService from '../../services/usuario_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const usuarioService = new UsuarioService();

let _this;
export default {
	name: 'ChangePass',
	props: {
		user: {}
	},
	data: function() {
		return {
			titulo: 'CAMBIAR PASSWORD',
			data: {},
			generalService: generalService,
			validaciones: {},
			loginService: loginService,
			submited: false,
		} 
	}, 
	created: function () {
		if(!loginService.esAdministrador()) {
			_this.resetModal();
			return;
		}
		_this = this;
		this.submited = false;
		_this = this;
		this.getData();
	}, 
	methods: { 
		getData: function() {
			this.submited = true;
			if(_this.user != undefined && _this.user.idUser != undefined && _this.user.idUser > 0) {
				_this.data.idUser = _this.user.idUser;
				/*if(!loginService.hasPermission("activar", "tags")) {
					routeService.goToHome();
					return;
				}*/
				usuarioService.get({idUser: this.data.idUser}).then(function(response) {
					_this.data = {};
					_this.submited = false;
					if(response.body == null) {
						alertService.showAlert('danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert('danger', 'Error!', response.body.message);
						return;
					}
					if(response.body.length > 0) {
						for (let value of response.body) {
							_this.data = {
								idUser: value.idUser,
								name: value.name,
								lastName: value.lastName,
								dni: value.dni,
								uName: value.uName,
								emailUser: value.emailUser,							
								activoUser: value.activoUser == 1 ? 'SI' : 'NO',
							}; 
						} 
					} else {
						_this.resetModal();
					} 
				}, function(error) { 
					_this.submited = false;
					generalService.showRequestErrors(error);
					_this.resetModal();
					return;
				});
			} else {
				_this.resetModal();
				return;
			}
		},
		save: function() {
			let errores = this.validar();
			if (errores) {
				alertService.showAlert(this.$bvModal, 'warning', 'Advertencia', 'No se completaron correctamente los datos.\nVerifique los errores en el formulario.');
				return;
			}
			let data = {
				idUser: this.data.idUser,
				name: this.data.name,
				lastName: this.data.lastName,
				dni: this.data.dni,
				uName: this.data.uName,
				emailUser: this.data.emailUser,	
				uPassword: this.data.uPassword, 
				rol: this.data.rol, 							
				activoUser: this.data.activoUser == 1 ? 'SI' : 'NO',
				/*col1Tag: this.data.col1Tag,
				col2Tag: this.data.col2Tag,
				col3Tag: this.data.col3Tag,*/
			}; 
			this.submited = true;
			usuarioService.save(data).then(function(response) {
				if(response.body && response.body.status == 'success') {
					alertService.showSuccessToast('Datos guardados con exito.'); 
				} else {
					alertService.showAlert(this.$bvModal, 'warning', 'Advertencia', 'Se produjo un error al guardar los datos');
					return;
				}
				_this.resetModal();
				_this.submited = false; 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		validar: function() {
			let validaciones = {};
			let errores = false;
			if (typeof this.data.name == 'undefined' || this.data.name == '') {
				errores = true;
				validaciones['name'] = {errores: ['El nombre es obligatorio.'], estado: false};
			}
			if (typeof this.data.uName == 'undefined' || this.data.uName == '') {
				errores = true;
				validaciones['uName'] = {errores: ['El nombre de usuario es obligatorio.'], estado: false};
			}
			if (typeof this.data.emailUser == 'undefined' || this.data.emailUser == '') {
				errores = true;
				validaciones['emailUser'] = {errores: ['El email es obligatorio.'], estado: false};
			}
			if ((typeof this.data.uPassword == 'undefined' || this.data.uPassword == '') && (typeof this.data.idUser == 'undefined')) {
				errores = true;
				validaciones['uPassword'] = {errores: ['El password es obligatorio.'], estado: false};
			}
			this.validaciones = validaciones;
			return errores;
		},
		limpiarError: function (campo) {
			if (campo == undefined || campo.errores.length == 0) {
				return true;
			}
			campo.errores.length = 0;
			campo.estado = true;
		},
		cancelar: function() {
			_this.resetModal();
		},
		resetModal: function() {
			_this.data = {};
			if(_this.$refs['change-pass'])
				_this.$refs['change-pass'].hide();
		}
	}
}

